export const firebaseConfig = {
  apiKey: 'AIzaSyDkJfJ8hHMGkmBjGE7RDHSxIXMqBQZuXew',
  authDomain: 'museum-838f3.firebaseapp.com',
  databaseURL: 'https://museum-838f3.firebaseio.com',
  projectId: 'museum-838f3',
  storageBucket: 'museum-838f3.appspot.com',
  messagingSenderId: '527380070491',
  appId: '1:527380070491:web:2009efb67b996d90787f7e',
};
